export default __webpack_public_path__ + "static/sydereal-493090d65dc5402668481029c5b39ccf.png";